import React, {Component} from 'react';
import ReactDom from 'react-dom';
import './Atts.css'
import pic404large from './Att-404-pic/large.jpg';
import pic404small from './Att-404-pic/small.jpg';


export default class extends Component {
    clickAtt(index) {
        const atts = this.props.data,
            att = atts[index];

        if(att.type==="Video") {
            if(att.mark.indexOf('lost')>=0) {
                let retStr = `《${att.video_title}》\n` + att.video_url +
                             '\n\n由于经历了岁月变迁，该视频现已丢失 :(';
                return alert(retStr);
            }

            window.open(att.video_url, '_blank');
        }
    }

    render() {
        const atts = this.props.data;
        if(!atts.length)  return null;

        return (
            <ul className="atts">
                {this.buildAttDoms()}
            </ul>
        )
    }

    buildAttDoms() {
        const ret = [],
            atts = this.props.data;

        for(let i=0; i<atts.length; i++) {
            const att = atts[i];

            // layerClassName
            let layerClassName = "att-layer ";
            if(att.type==="Video")
                layerClassName += 'layer-video';
            else if(att.filename.indexOf('gif')>=0)
                layerClassName += 'layer-gif';

            let thumbUrl = process.env.PUBLIC_URL + '/pics/thumb/' + att.thumb_name,
                fileUrl = process.env.PUBLIC_URL + '/pics/atts/' + att.filename;
            if(att.type==="Pic" && att.mark==='lost') {
                thumbUrl = pic404small;
                fileUrl = pic404large;
            }

            ret.push(
                <li className="att-item" key={att.filename} onClick={this.clickAtt.bind(this, i)}>
                    <div className={layerClassName} data-src={fileUrl}>
                        <div className="img" style={{backgroundImage: `url(${thumbUrl})`}} />
                    </div>
                </li>
            );
        }

        return ret;
    }


    componentDidMount () {
        // Load lightGallery
        const dom = ReactDom.findDOMNode(this);
        global.lightGallery(dom, {
            selector: '.att-layer:not(.layer-video)'
        });
    }
}



// WEBPACK FOOTER //
// ./src/main-content/weibo-module/Atts.js